/**
 * Dependencies
 */
import { cloneDeep } from 'lodash'

/**
 * State Declaration
 *
 * @type {Object}
 */
const base = {
    project: {},
    form: {
        pending: false,
        successMessage: null,
        email: '',
        level: null,
        error: null
    },
    showDialog: false,
    link: {
        pending: false,
        url: null,
        pin: null
    }
}

export const getState = () => cloneDeep(base)

export default getState()



// WEBPACK FOOTER //
// ./src/state/modules/projects/share/state.js